import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";
import { useAuth } from "@/components/contexts/AuthContext/UseAuth";
import { LoadingDots } from "@/components/ui/LoadingDots";

const LoginCallback = () => {
  const navigate = useNavigate();
  const { completeLogin } = useAuth();
  const hasProcessedLogin = useRef(false);

  useEffect(() => {
    const completeLoginFlow = async () => {
      try {
        console.log("Completing login...");
        hasProcessedLogin.current = true;
        const returnUrl = await completeLogin();

        navigate(returnUrl);
      } catch (error) {
        console.error("Login failed:", error);
        navigate("/");
      }
    };

    if (!hasProcessedLogin.current) {
      completeLoginFlow();
    }
  }, [completeLogin, navigate]);

  return (
    <div className="flex justify-center items-center h-screen">
      <LoadingDots />
    </div>
  );
};

export default LoginCallback;
